module.exports = __webpack_public_path__ + "static/media/calendar.9c06274c.svg";